module.exports = __webpack_public_path__ + "img/humanoid.2f4181ea.png";